import type { TActiveGateway, TActiveNode } from '../types'

export const nodeBelongsToProperty = (node: TActiveNode | TActiveGateway, propertyId?: number | null) => {
  if (!propertyId) return false

  if ((node as TActiveNode).propertyId && (node as TActiveNode).propertyId === propertyId) return true

  return (node as TActiveGateway).propertyIds && (node as TActiveGateway).propertyIds.includes(propertyId)
}
